<template>
    <div class="wrap">
        <div>
            <div>
                <el-button @click="addCity" type="primary" icon="el-icon-circle-plus-outline">添加开通城市</el-button>
            </div>
            <div class="mt20">
                <el-input placeholder="城市名称/区域编码" class="w300 seekIpt" v-model="keyWord" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-select class="w120  ml20" v-model="ableVal" clearable placeholder="启用/禁用" @change="ableChange">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="w300  ml20" v-model="miniAppType" multiple clearable placeholder="小程序类型" @change="ableChange" size="small">
                    <el-option v-for="(val,key,i) in miniAppTypeObj" :key="key" :label="val" :value="key"></el-option>
                </el-select>
            </div>
        </div>
        <div class="mt10">
            <el-table :data="tableData" class="table-div r30 allDown movePoin" v-loading="tableLoading">
                <el-table-column show-overflow-tooltip width="60" label="序号">
                    <template slot-scope="scope">
                        {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="areaName" label="城市名称" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.areaName?scope.row.areaName:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="areaId" label="区域编码" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.areaId?scope.row.areaId:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="lng" label="经度" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.lng?scope.row.lng:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="lat" label="纬度" min-width="100">
                    <template slot-scope="scope">
                        <span>{{scope.row.lat?scope.row.lat:'-'}}</span>
                    </template>
                </el-table-column>
                 <el-table-column show-overflow-tooltip prop="miniAppType_" label="小程序类型" min-width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="available" label="是否启用" min-width="100">
                    <template slot-scope="scope">
                        <!-- <el-switch v-model="scope.row.available" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否" style="margin-left:-26px"></el-switch> -->
                        <span>{{scope.row.available?scope.row.available:'-'}}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" min-width="240">
                    <template slot-scope="scope">
                        <el-button @click="detail(scope.row)" type="info" plain>详情</el-button>
                        <el-button @click="edit(scope.row)" type="warning" plain>编辑</el-button>
                        <el-button @click="del(scope.row)" type="danger" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:20px;"></ybPagination>
            <city-dialog v-if="cityDialogVisible" :cityData="cityData" :city-dialog-visible="cityDialogVisible" @closeCityDialog="closeCityDialogVisible"></city-dialog>
        </div>
        
    </div>
</template>
<script>
import ybPagination from '@/components/ybPagination'
import CityDialog from './CityDialog'
import * as cityApi from '@/api/city'
import * as mapping from '@/utils/enumList'
export default {
    components: {
        ybPagination,
        CityDialog
    },
    data() {
        return {
            miniAppType:[],
            miniAppTypeObj: {
                    'FXSA': '放心食安',
                    'XCWS': '校餐卫士',
                    'HNYSA': '河南豫食安'
                },
            keyWord: '',
            ableVal: '',
            options: [{
                label: '启用',  
                value: '1'
            }, {
                label: '禁用',
                value: '0'
            }],
            tableData:[],
            tableLoading: false,
            page: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            cityData: {
                type: '',
                id: ''
            },
            cityDialogVisible: false
        }
    },
    computed: {
        queryParams: function() {
            return {
                current: this.page.pageNum,
                size: this.page.pageSize,
                keyword: this.keyWord,
                available: this.ableVal,
                miniAppType:this.miniAppType.toString()
            }
        }
    },
    methods: {
        // 启用禁用筛选
        ableChange(val) {
            this.page.pageNum = 1;
            this.getCityList();
        },
        // 搜索筛选
        search() {
            this.page.pageNum = 1;
            this.getCityList();
        },
        getCityList() {
            this.tableLoading = true;
            cityApi.getCityList(this.queryParams).then(r=>{
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el=>{
                        el.available = mapping.keyToVal('available', el.available)
                        el.miniAppType = el.miniAppType.split(",")
                        el.miniAppType_ = '';
                        el.miniAppType.map(item => {
                            el.miniAppType_=el.miniAppType_+this.miniAppTypeObj[item]+','
                        })
                    })
                    this.tableData = data;
                    this.page.total = r.data.total;
                    this.tableLoading = false;
                }
                this.tableLoading = false;
            }).catch(e=>{})
        },
        // 添加配置
        addCity() {
            this.cityData.type = 'isAdd';
            this.cityDialogVisible = true;
        },
        // 详情
        detail(row) {
            this.cityData.type = 'isDetail';
            this.cityData.id = row.id;
            this.cityDialogVisible = true;
        },
        // 编辑
        edit(row) {
            this.cityData.type = 'isEdit';
            this.cityData.id = row.id;
            this.cityDialogVisible = true;
        },
        // 删除
        del(row) {
            this.$confirm('是否确认删除开通城市? 此操作不可恢复!', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cityApi.delCity({id: row.id}).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功!');
                    }
                    this.getCityList();
                })
            }).catch(e => {})
        },
        // 关闭dialog
        closeCityDialogVisible() {
            this.cityDialogVisible = false;
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getCityList();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getCityList();
            }
        }
    },
    mounted() {
        this.getCityList();
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
    }
</style>